import * as Page from '../pages';

import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import classNames from 'classnames/bind';
import style from './style.module.scss';

const cx = classNames.bind(style);

function Router() {
  const routes = Object.keys(Page).map((pageName) => Page[pageName]);
  console.log(Page);
  return (
    <div className={cx('router')}>
      <Switch>
        {routes.map((route) => {
          return (
            <Route
              key={route?.path}
              exact
              path={route?.path}
              component={route.loginRequired ? notLoginedRedirect(route.default) : route.default}
            />
          );
        })}
        {/* <Redirect path="*" to="/" /> */}
      </Switch>
    </div>
  );
}

export default Router;
